import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Cutlery = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M9.167 10.333a.5.5 0 1 0-1 0zm-1 10a.5.5 0 0 0 1 0zM8.164 7a.5.5 0 0 0 1 0zm1-4a.5.5 0 0 0-1 0zm9.335 9.059a.5.5 0 0 0-1 0zm-1 8.236a.5.5 0 1 0 1 0zM18 3h.5a.5.5 0 0 0-.858-.35zm0 10.667v.5a.5.5 0 0 0 .5-.5zm-4.589-.785.498.048zM6.5 3a.5.5 0 0 0-1 0zm5.333 0a.5.5 0 1 0-1 0zm-3.167 7.333h-.5v10h1v-10zm0-3.333h.5V3h-1v4zM18 12.059h-.5v8.236h1v-8.236zM18 3l-.358-.35a16.9 16.9 0 0 0-4.728 10.184l.497.048.498.048a15.9 15.9 0 0 1 4.449-9.58zm-3.858 10.667v.5H18v-1h-3.858zm3.858 0h.5V3h-1v10.667zm-4.589-.785-.497-.048c-.072.736.52 1.333 1.228 1.333v-1c-.15 0-.244-.12-.233-.237zM6 3h-.5v4.556h1V3zm0 4.556h-.5c0 .84.334 1.645.928 2.24l.353-.354.354-.354A2.17 2.17 0 0 1 6.5 7.556zm.781 1.886-.353.353a3.16 3.16 0 0 0 2.239.928v-1a2.17 2.17 0 0 1-1.532-.635zm1.886.78v.5c.84 0 1.645-.333 2.239-.927l-.354-.353-.353-.354a2.17 2.17 0 0 1-1.532.635zm1.885-.78.354.353c.594-.594.927-1.4.927-2.239h-1c0 .575-.228 1.126-.634 1.532zm.781-1.886h.5V3h-1v4.556z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Cutlery) as SvgIcon;
export { ForwardRef as ReactComponent };
